import {
    executeDeleteMethod,
    executeFilePostMethod, executeJsonGetMethod, executeJsonPostMethod, executeJsonPutMethod, executePostMethod
} from '../api/rest/restApiUtils'

export function getBooks() {
    return executeJsonGetMethod(`/books`,).then((resp) => {
        return resp.data.content;
    })
}

export function getBook(id: number, width: number, height: number, fontSize: number, lineHeight: number) {
    return executeJsonGetMethod(`/books/${id}?width=${width}&height=${height}&fontSize=${fontSize}&lineHeight=${lineHeight}`).then((resp) => {
        return resp.data;
    })
}

export function saveUserBookPagination(id: number, width: number, height: number, fontSize: number, lineHeight: number, tempAllPages: Array<any>, tempCharCounts: Array<number>) {
    const req = {
        tempAllPages: tempAllPages,
        tempCharCounts: tempCharCounts
    }

    return executeJsonPostMethod(`/books/${id}?width=${width}&height=${height}&fontSize=${fontSize}&lineHeight=${lineHeight}`, req).then((resp) => {
        return resp.data;
    })
}

export function deleteBook(id: number) {
    return executeDeleteMethod(`/books/${id}`,)
}


export function uploadBook(file: any) {
    let formData = new FormData()
    formData.append('file', file)
    return executeFilePostMethod(`/books`, formData).then((resp) => {
        return resp.json()
    })
}

export function getBookmarks(id: number) {
    return executeJsonGetMethod(`/books/${id}/bookmark`);
}

export function createBookmark(id: number, title: string, offset: number, localTime: string) {
    let sendingData = {
        title: title,
        offset: offset,
        localTime: localTime
    }
    return executeJsonPostMethod(`/books/${id}/bookmark`, sendingData);
}

export function deleteBookmark(id: number, bookMarkId: number) {
    return executeDeleteMethod(`/books/${id}/bookmark/${bookMarkId}`);
}

export function getCatalogBooks() {
    return executeJsonGetMethod(`/catalog/books`).then((resp) => {
        return resp.data.content;
    })
}

export function uploadCatalogBook(file: any) {
    let formData = new FormData()
    formData.append('file', file)
    return executeFilePostMethod(`/catalog/books`, formData).then((resp) => {
        return resp.json()
    })
}

export function deleteCatalogBook(id: number) {
    return executeDeleteMethod(`/catalog/books/${id}`)
}

export function addCatalogBookToLibrary(id: number) {
    return executePostMethod(`/catalog/books/${id}/add`)
}

export function bindBook(
    id: number,
    listId?: number,
    sideOneLang?: string,
    sideTwoLang?: string
) {
    const params = new URLSearchParams();

    if (listId !== undefined) {
        params.append("wordsListId", listId.toString());
    }
    if (sideOneLang) {
        params.append("sideOneLang", sideOneLang);
    }
    if (sideTwoLang) {
        params.append("sideTwoLang", sideTwoLang);
    }

    return executePostMethod(
        `/books/${id}/binding?${params.toString()}`
    );
}
